/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';


const defaultProps = {
  error: null,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  error: React.PropTypes.string,
  onHide: React.PropTypes.func.isRequired,
};

class DeleteErrorModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: props.error,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.detailview.delete');
  }

  componentWillReceiveProps(nextProps) {
    const { error } = nextProps;
    if (error !== this.props.error) {
      this.setState({ error });
    }
  }

  render() {
    const { onHide } = this.props;
    const { error } = this.state;
    return (
      <Modal
        bsClass="aisz-modal-warning"
        show={!_.isNil(error)}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" />
            {' '}
            {this.intlMsg.msg('error.modalheader')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            {this.intlMsg.errorMsg(error)}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

DeleteErrorModal.defaultProps = defaultProps;
DeleteErrorModal.propTypes = propTypes;

export default injectIntl(DeleteErrorModal);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/DeleteErrorModal/index.jsx